import { render, staticRenderFns } from "./BuildingFloor.vue?vue&type=template&id=831c9c2e&scoped=true&lang=pug&"
import script from "./BuildingFloor.vue?vue&type=script&lang=ts&"
export * from "./BuildingFloor.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingFloor.vue?vue&type=style&index=0&id=831c9c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831c9c2e",
  null
  
)

export default component.exports